// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main wrapper */
.wrapper-foodspot {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  /* Left informational panel */
  /* Right form panel */
}
.wrapper-foodspot .left {
  width: 35%;
  background: #F3F3F3;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
}
.wrapper-foodspot .left h3 {
  font-size: 17px;
  line-height: 24px;
  margin: 0 0 20px 0;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}
.wrapper-foodspot .left p {
  margin: 0;
  line-height: 22px;
  color: var(--ion-color-secondary);
  font-size: 14px;
}
.wrapper-foodspot .left a {
  text-decoration: none;
  font-weight: bold;
  color: var(--ion-color-primary);
}
.wrapper-foodspot .left a:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.wrapper-foodspot .right {
  width: 65%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background: white;
  /* Header section */
  /* Input section */
  /* Spacer for layout */
}
.wrapper-foodspot .right .header-section {
  padding: 20px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid rgb(243, 243, 243);
  /* Close button */
}
.wrapper-foodspot .right .header-section h2 {
  margin: 0;
  font-size: 18px;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}
.wrapper-foodspot .right .header-section .close-button {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.wrapper-foodspot .right .header-section .close-button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.wrapper-foodspot .right .header-section .close-button:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.wrapper-foodspot .right .header-section .close-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.wrapper-foodspot .right .header-section .close-button:active {
  transform: translateY(-50%) scale(0.95);
}
.wrapper-foodspot .right .header-section .close-button ion-icon {
  font-size: 24px;
  color: var(--ion-color-secondary);
}
.wrapper-foodspot .right .input-section {
  width: 100%;
  padding: 30px 20px;
  flex: 1;
  /* Code form */
  /* Input block */
}
.wrapper-foodspot .right .input-section p {
  margin: 0 0 20px 0;
  line-height: 22px;
  color: var(--ion-color-secondary);
  font-size: 14px;
}
.wrapper-foodspot .right .input-section .code-form {
  width: 100%;
}
.wrapper-foodspot .right .input-section .input-block {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;
  /* Input field */
  /* Submit button */
}
.wrapper-foodspot .right .input-section .input-block .code-input {
  flex: 1;
  border: 2px solid #F3F3F3;
  border-radius: 20px;
  padding: 0;
  --padding-top: 15px;
  --padding-bottom: 15px;
  --padding-start: 20px;
  --padding-end: 20px;
  --highlight-color-focused: var(--ion-color-primary);
  --border-color: transparent;
  --box-shadow: none;
  cursor: text;
  font-size: 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  /* Focus styles */
  /* Error state */
  /* Placeholder styling */
}
.wrapper-foodspot .right .input-section .input-block .code-input:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.wrapper-foodspot .right .input-section .input-block .code-input.error {
  border-color: #d32f2f;
}
.wrapper-foodspot .right .input-section .input-block .code-input.error:focus-within {
  box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.25);
}
.wrapper-foodspot .right .input-section .input-block .code-input::placeholder {
  color: #999;
  opacity: 1;
}
.wrapper-foodspot .right .input-section .input-block .submit-button {
  --background: var(--ion-color-primary);
  --color: white;
  --border-radius: 20px;
  --padding-top: 15px;
  --padding-bottom: 15px;
  --padding-start: 25px;
  --padding-end: 25px;
  text-transform: capitalize;
  font-family: AppFontBold, sans-serif;
  min-width: 100px;
  /* Focus styles */
  /* Disabled state */
}
.wrapper-foodspot .right .input-section .input-block .submit-button:focus {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.4);
}
.wrapper-foodspot .right .input-section .input-block .submit-button:disabled {
  --background: #cccccc;
  --color: #666666;
  cursor: not-allowed;
}
.wrapper-foodspot .right .spacer {
  height: 20px;
}

/* Error message styling */
.error-message {
  margin-top: 10px;
}
.error-message span {
  color: #d32f2f;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  /* Add icon before error text */
}
.error-message span::before {
  content: "⚠";
  margin-right: 5px;
  font-size: 14px;
}

/* Remove default input underline */
ion-input.no-underline {
  --border-color: transparent;
  --box-shadow: none;
}

/* High contrast mode enhancements */
.bsg-high-contrast .wrapper-foodspot {
  border: 2px solid black;
}
.bsg-high-contrast .wrapper-foodspot .left {
  background: white;
  border-right: 2px solid black;
}
.bsg-high-contrast .wrapper-foodspot .left h3, .bsg-high-contrast .wrapper-foodspot .left p {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .left a {
  color: #0078d7 !important;
  text-decoration: underline;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section {
  border-bottom: 2px solid black;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section h2 {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section .close-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .wrapper-foodspot .right .header-section .close-button ion-icon {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section p {
  color: black !important;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .code-input {
  border-color: black;
  background: white;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .code-input:focus-within {
  border-color: #0078d7;
  box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .code-input.error {
  border-color: black;
  border-style: dashed;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button {
  --background: black;
  --color: white;
  border: 2px solid white;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button span {
  color: white !important;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button:focus {
  box-shadow: 0 0 0 3px #0078d7;
}
.bsg-high-contrast .wrapper-foodspot .right .input-section .input-block .submit-button:disabled {
  --background: #666666;
  border: 1px dashed black;
}
.bsg-high-contrast .error-message span {
  color: black !important;
  background: #ffcccc;
  padding: 5px;
  border: 1px solid black;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .wrapper-foodspot {
    flex-direction: column;
    height: auto;
  }
  .wrapper-foodspot .left {
    width: 100%;
    height: auto;
    padding: 15px;
  }
  .wrapper-foodspot .right {
    width: 100%;
  }
  .wrapper-foodspot .right .header-section {
    padding: 15px 20px;
  }
  .wrapper-foodspot .right .header-section .close-button {
    right: 15px;
  }
  .wrapper-foodspot .right .input-section {
    padding: 20px 15px;
  }
  .wrapper-foodspot .right .input-section .input-block {
    flex-direction: column;
    gap: 15px;
  }
  .wrapper-foodspot .right .input-section .input-block .submit-button {
    width: 100%;
  }
}
ion-button {
  color: white !important;
}
ion-button span {
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/enter-foodspot-code-modal/enter-foodspot-code-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,4BAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAEJ;;AACE,iBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EAEA,6BAAA;EAqCA,qBAAA;AAnCJ;AADI;EACE,UAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;AAGN;AADM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;AAGR;AAAM;EACE,SAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;AAER;AACM;EACE,qBAAA;EACA,iBAAA;EACA,+BAAA;AACR;AACQ;EACE,2CAAA;EACA,mBAAA;AACV;AAKI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;EAEA,mBAAA;EA0DA,kBAAA;EA4FA,sBAAA;AAxJN;AAGM;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;EASA,iBAAA;AATR;AAEQ;EACE,SAAA;EACA,eAAA;EACA,iCAAA;EACA,oCAAA;AAAV;AAIQ;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAjBV;AACU;EACE,2CAAA;EACA,mBAAA;AACZ;AAGU;EACE,2CAAA;EACA,mBAAA;AADZ;AAKU;EACE,qCAAA;AAHZ;AAOU;EACE,uCAAA;AALZ;AAQU;EACE,eAAA;EACA,iCAAA;AANZ;AAYM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EASA,cAAA;EAKA,gBAAA;AAtBR;AAUQ;EACE,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;AARV;AAYQ;EACE,WAAA;AAVV;AAcQ;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EAEA,gBAAA;EAuCA,kBAAA;AAnDV;AAaU;EACE,OAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mDAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,wDAAA;EAEA,iBAAA;EAMA,gBAAA;EASA,wBAAA;AAzBZ;AAWY;EACE,sCAAA;EACA,8CAAA;AATd;AAaY;EACE,qBAAA;AAXd;AAac;EACE,6CAAA;AAXhB;AAgBY;EACE,WAAA;EACA,UAAA;AAdd;AAmBU;EACE,sCAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,0BAAA;EACA,oCAAA;EACA,gBAAA;EAEA,iBAAA;EAKA,mBAAA;AAtBZ;AAkBY;EACE,6CAAA;AAhBd;AAoBY;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;AAlBd;AAyBM;EACE,YAAA;AAvBR;;AA4BE,0BAAA;AACA;EACE,gBAAA;AAzBJ;AA2BI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,+BAAA;AA1BN;AA2BM;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AAzBR;;AA8BE,mCAAA;AACA;EACE,2BAAA;EACA,kBAAA;AA3BJ;;AA8BE,oCAAA;AAEE;EACE,uBAAA;AA5BN;AA8BM;EACE,iBAAA;EACA,6BAAA;AA5BR;AA8BQ;EACE,uBAAA;AA5BV;AA+BQ;EACE,yBAAA;EACA,0BAAA;AA7BV;AAkCQ;EACE,8BAAA;AAhCV;AAkCU;EACE,uBAAA;AAhCZ;AAoCY;EACE,0BAAA;AAlCd;AAqCY;EACE,uBAAA;AAnCd;AAyCU;EACE,uBAAA;AAvCZ;AA2CY;EACE,mBAAA;EACA,iBAAA;AAzCd;AA2Cc;EACE,qBAAA;EACA,6CAAA;AAzChB;AA4Cc;EACE,mBAAA;EACA,oBAAA;AA1ChB;AA8CY;EACE,mBAAA;EACA,cAAA;EACA,uBAAA;AA5Cd;AA6Cc;EACE,uBAAA;AA3ChB;AA6Cc;EACE,6BAAA;AA3ChB;AA8Cc;EACE,qBAAA;EACA,wBAAA;AA5ChB;AAoDI;EACE,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAlDN;;AAsDE,2BAAA;AACA;EACE;IACE,sBAAA;IACA,YAAA;EAnDJ;EAqDI;IACE,WAAA;IACA,YAAA;IACA,aAAA;EAnDN;EAsDI;IACE,WAAA;EApDN;EAsDM;IACE,kBAAA;EApDR;EAsDQ;IACE,WAAA;EApDV;EAwDM;IACE,kBAAA;EAtDR;EAwDQ;IACE,sBAAA;IACA,SAAA;EAtDV;EAwDU;IACE,WAAA;EAtDZ;AACF;AA6DA;EACI,uBAAA;AA3DJ;AA4DI;EACI,uBAAA;AA1DR","sourcesContent":["/* Accessibility utilities */\n.visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n  \n  /* Main wrapper */\n  .wrapper-foodspot {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    border-radius: 20px;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    \n    /* Left informational panel */\n    .left {\n      width: 35%;\n      background: #F3F3F3;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      padding: 20px;\n      \n      h3 {\n        font-size: 17px;\n        line-height: 24px;\n        margin: 0 0 20px 0;\n        color: var(--ion-color-secondary);\n        font-family: AppFontBold, sans-serif;\n      }\n      \n      p {\n        margin: 0;\n        line-height: 22px;\n        color: var(--ion-color-secondary);\n        font-size: 14px;\n      }\n      \n      a {\n        text-decoration: none;\n        font-weight: bold;\n        color: var(--ion-color-primary);\n        \n        &:focus {\n          outline: 2px solid var(--ion-color-primary);\n          outline-offset: 2px;\n        }\n      }\n    }\n    \n    /* Right form panel */\n    .right {\n      width: 65%;\n      height: 100%;\n      display: flex;\n      justify-content: space-between;\n      flex-direction: column;\n      background: white;\n      \n      /* Header section */\n      .header-section {\n        padding: 20px;\n        text-align: center;\n        position: relative;\n        border-bottom: 1px solid rgba(243, 243, 243, 1);\n        \n        h2 {\n          margin: 0;\n          font-size: 18px;\n          color: var(--ion-color-secondary);\n          font-family: AppFontBold, sans-serif;\n        }\n        \n        /* Close button */\n        .close-button {\n          position: absolute;\n          right: 20px;\n          top: 50%;\n          transform: translateY(-50%);\n          background: transparent;\n          border: none;\n          padding: 8px;\n          cursor: pointer;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          \n          /* Focus styles */\n          &:focus {\n            outline: 2px solid var(--ion-color-primary);\n            outline-offset: 2px;\n          }\n          \n          /* Keyboard focus styles */\n          &:focus-visible {\n            outline: 2px solid var(--ion-color-primary);\n            outline-offset: 2px;\n          }\n          \n          /* Hover state */\n          &:hover {\n            background-color: rgba(0, 0, 0, 0.05);\n          }\n          \n          /* Active state */\n          &:active {\n            transform: translateY(-50%) scale(0.95);\n          }\n          \n          ion-icon {\n            font-size: 24px;\n            color: var(--ion-color-secondary);\n          }\n        }\n      }\n      \n      /* Input section */\n      .input-section {\n        width: 100%;\n        padding: 30px 20px;\n        flex: 1;\n        \n        p {\n          margin: 0 0 20px 0;\n          line-height: 22px;\n          color: var(--ion-color-secondary);\n          font-size: 14px;\n        }\n        \n        /* Code form */\n        .code-form {\n          width: 100%;\n        }\n        \n        /* Input block */\n        .input-block {\n          display: flex;\n          align-items: flex-start;\n          gap: 10px;\n          margin-bottom: 15px;\n          \n          /* Input field */\n          .code-input {\n            flex: 1;\n            border: 2px solid #F3F3F3;\n            border-radius: 20px;\n            padding: 0;\n            --padding-top: 15px;\n            --padding-bottom: 15px;\n            --padding-start: 20px;\n            --padding-end: 20px;\n            --highlight-color-focused: var(--ion-color-primary);\n            --border-color: transparent;\n            --box-shadow: none;\n            cursor: text;\n            font-size: 16px;\n            transition: border-color 0.2s ease, box-shadow 0.2s ease;\n            \n            /* Focus styles */\n            &:focus-within {\n              border-color: var(--ion-color-primary);\n              box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n            }\n            \n            /* Error state */\n            &.error {\n              border-color: #d32f2f;\n              \n              &:focus-within {\n                box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.25);\n              }\n            }\n            \n            /* Placeholder styling */\n            &::placeholder {\n              color: #999;\n              opacity: 1;\n            }\n          }\n          \n          /* Submit button */\n          .submit-button {\n            --background: var(--ion-color-primary);\n            --color: white;\n            --border-radius: 20px;\n            --padding-top: 15px;\n            --padding-bottom: 15px;\n            --padding-start: 25px;\n            --padding-end: 25px;\n            text-transform: capitalize;\n            font-family: AppFontBold, sans-serif;\n            min-width: 100px;\n            \n            /* Focus styles */\n            &:focus {\n              box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.4);\n            }\n            \n            /* Disabled state */\n            &:disabled {\n              --background: #cccccc;\n              --color: #666666;\n              cursor: not-allowed;\n            }\n          }\n        }\n      }\n      \n      /* Spacer for layout */\n      .spacer {\n        height: 20px;\n      }\n    }\n  }\n  \n  /* Error message styling */\n  .error-message {\n    margin-top: 10px;\n    \n    span {\n      color: #d32f2f;\n      font-size: 12px;\n      font-weight: 500;\n      display: flex;\n      align-items: center;\n      \n      /* Add icon before error text */\n      &::before {\n        content: '⚠';\n        margin-right: 5px;\n        font-size: 14px;\n      }\n    }\n  }\n  \n  /* Remove default input underline */\n  ion-input.no-underline {\n    --border-color: transparent;\n    --box-shadow: none;\n  }\n  \n  /* High contrast mode enhancements */\n  .bsg-high-contrast {\n    .wrapper-foodspot {\n      border: 2px solid black;\n      \n      .left {\n        background: white;\n        border-right: 2px solid black;\n        \n        h3, p {\n          color: black !important;\n        }\n        \n        a {\n          color: #0078d7 !important;\n          text-decoration: underline;\n        }\n      }\n      \n      .right {\n        .header-section {\n          border-bottom: 2px solid black;\n          \n          h2 {\n            color: black !important;\n          }\n          \n          .close-button {\n            &:focus {\n              outline: 3px solid #0078d7;\n            }\n            \n            ion-icon {\n              color: black !important;\n            }\n          }\n        }\n        \n        .input-section {\n          p {\n            color: black !important;\n          }\n          \n          .input-block {\n            .code-input {\n              border-color: black;\n              background: white;\n              \n              &:focus-within {\n                border-color: #0078d7;\n                box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);\n              }\n              \n              &.error {\n                border-color: black;\n                border-style: dashed;\n              }\n            }\n            \n            .submit-button {\n              --background: black;\n              --color: white;\n              border: 2px solid white;\n              span {\n                color: white !important;\n              }\n              &:focus {\n                box-shadow: 0 0 0 3px #0078d7;\n              }\n              \n              &:disabled {\n                --background: #666666;\n                border: 1px dashed black;\n              }\n            }\n          }\n        }\n      }\n    }\n    \n    .error-message span {\n      color: black !important;\n      background: #ffcccc;\n      padding: 5px;\n      border: 1px solid black;\n    }\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .wrapper-foodspot {\n      flex-direction: column;\n      height: auto;\n      \n      .left {\n        width: 100%;\n        height: auto;\n        padding: 15px;\n      }\n      \n      .right {\n        width: 100%;\n        \n        .header-section {\n          padding: 15px 20px;\n          \n          .close-button {\n            right: 15px;\n          }\n        }\n        \n        .input-section {\n          padding: 20px 15px;\n          \n          .input-block {\n            flex-direction: column;\n            gap: 15px;\n            \n            .submit-button {\n              width: 100%;\n\n            }\n          }\n        }\n      }\n    }\n  }\nion-button {\n    color: white !important;\n    span {\n        color: white !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
